const accountingAutomatorKey = '/accounting-automator';

export const sortDocuments = () => `${accountingAutomatorKey}/sortDocuments`;
export const getFolderByLink = (driveLink: string) =>
  `${accountingAutomatorKey}/folders?driveLink=${driveLink}`;
